// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-table-container {
  display: flex;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: auto;
}

.category-table-wrapper {
  width: 100%;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 0 auto;
}

.category-table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.category-table-heading {
  text-align: center;
  font-family: "Fivo Sans Medium", sans-serif;
  margin-bottom: 20px;
}

.table-wrapper {
  overflow-x: auto;
  text-align: left;
}

.category-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 1em;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
/* .selected-cell {
  background-color: #e0f7fa !important;
  border: 1px solid #007bff;
} */
.category-table-row-heading,
.category-table-row-detail {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}

.category-table tr:nth-child(even) {
  background-color: #ffffff;
}

.category-table tr:nth-child(odd) {
  background-color: #f3f3f3;
}

.category-table th {
  background-color: #f4f4f4;
  font-size: 0.9em;
  font-weight: bold;
  font-family: "Fivo Sans Medium", sans-serif;
  white-space: nowrap;
}

.category-table th .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.category-table th .header-label {
  margin-right: 0.625em;
}

.category-table th .sort-icon {
  vertical-align: middle;
}

.category-table td {
  font-size: 0.9em;
  font-family: "Fivo Sans Regular", sans-serif;
}

.category-table td img {
  max-width: 100px;
  height: auto;
  display: block;
}

.category-table td a {
  color: #007bff;
  text-decoration: none;
}

.category-table td a:hover {
  color: #007bff;
  text-decoration: none;
}
.filter-icon {
  color: gray;
  cursor: pointer;
}
.filter-icon-active {
  color: #b51d22;
}
.category-pagination {
  display: flex;
  justify-content: center;
  margin-top: 1.25em 0;
}
.pagination-button {
  background-color: #28a745;
  border: 1px solid #ddd;
  padding: 0.875em 1.625em;
  margin: 0.5em 0.8em;
  cursor: pointer;
  border-radius: 0.3125em;
  font-family: "Fivo Sans Medium", sans-serif;
}
.pagination-button.active {
  background-color: #b51d22;
  color: white;
}
.pagination-button:hover {
  background-color: #218838;
  color: white;
}
.edit-button-container {
  display: flex;
  justify-content: space-between;
}
.bulk-edit-button {
  display: flex;
  justify-content: flex-end;
  padding: 0.625em;
  cursor: pointer;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1em;
  color: #b51d22;
}
.add-new-item-button {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  cursor: pointer;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1em;
  color: #b51d22;
}

.add-new-item-button .FaPlus {
  font-size: 1.5em;
  color: #28a745;
  cursor: pointer;
}

.add-new-item-button .FaPlus:hover {
  color: #218838;
}
.category-loading-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #007bff;
  animation: spin 1s ease infinite;
}
.checkbox-column {
  background-color: #f4f4f4;
}
.checkbox {
  cursor: pointer;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BrowseCollection/CategoryTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAAsB;EAAtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;;;GAGG;AACH;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,2CAA2C;EAC3C,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".category-table-container {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n  overflow-x: auto;\n}\n\n.category-table-wrapper {\n  width: 100%;\n  max-width: fit-content;\n  margin: 0 auto;\n}\n\n.category-table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.category-table-heading {\n  text-align: center;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  margin-bottom: 20px;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n  text-align: left;\n}\n\n.category-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 20px 0;\n  font-size: 1em;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n/* .selected-cell {\n  background-color: #e0f7fa !important;\n  border: 1px solid #007bff;\n} */\n.category-table-row-heading,\n.category-table-row-detail {\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.category-table tr:nth-child(even) {\n  background-color: #ffffff;\n}\n\n.category-table tr:nth-child(odd) {\n  background-color: #f3f3f3;\n}\n\n.category-table th {\n  background-color: #f4f4f4;\n  font-size: 0.9em;\n  font-weight: bold;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  white-space: nowrap;\n}\n\n.category-table th .header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.category-table th .header-label {\n  margin-right: 0.625em;\n}\n\n.category-table th .sort-icon {\n  vertical-align: middle;\n}\n\n.category-table td {\n  font-size: 0.9em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n}\n\n.category-table td img {\n  max-width: 100px;\n  height: auto;\n  display: block;\n}\n\n.category-table td a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.category-table td a:hover {\n  color: #007bff;\n  text-decoration: none;\n}\n.filter-icon {\n  color: gray;\n  cursor: pointer;\n}\n.filter-icon-active {\n  color: #b51d22;\n}\n.category-pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.25em 0;\n}\n.pagination-button {\n  background-color: #28a745;\n  border: 1px solid #ddd;\n  padding: 0.875em 1.625em;\n  margin: 0.5em 0.8em;\n  cursor: pointer;\n  border-radius: 0.3125em;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n.pagination-button.active {\n  background-color: #b51d22;\n  color: white;\n}\n.pagination-button:hover {\n  background-color: #218838;\n  color: white;\n}\n.edit-button-container {\n  display: flex;\n  justify-content: space-between;\n}\n.bulk-edit-button {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0.625em;\n  cursor: pointer;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1em;\n  color: #b51d22;\n}\n.add-new-item-button {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n  cursor: pointer;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1em;\n  color: #b51d22;\n}\n\n.add-new-item-button .FaPlus {\n  font-size: 1.5em;\n  color: #28a745;\n  cursor: pointer;\n}\n\n.add-new-item-button .FaPlus:hover {\n  color: #218838;\n}\n.category-loading-spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border-left-color: #007bff;\n  animation: spin 1s ease infinite;\n}\n.checkbox-column {\n  background-color: #f4f4f4;\n}\n.checkbox {\n  cursor: pointer;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
